/**
 * User: Rob Richard
 * Date: 9/3/14
 * Time: 6:56 PM
 */

'use strict';

var _ = require('underscore');
var Party = require('bunsen/models/Party');
var Offer = require('bunsen/models/ecomm/Offer');
var PaymentAuthorization = require('bunsen/models/ecomm/PaymentAuthorization');
var FinancialAmount = require('bunsen/models/FinancialAmount');

var getFromWallet = function (fn) {
    var shippingAddress = this.get('shipment.shippingAddress');
    var wallet = this.get('buyer.wallet');
    if (!wallet) {
        throw new Error('Must have buyer.wallet for getPermissibleCards to work');
    }
    return wallet[fn](shippingAddress);
};

module.exports = {
    /**
     * Saves the transaction, note, and sends the entire page to braintree
     */
    submitForCheckout: function () {
        this.addCheckoutNote();

        return this.save(null, {
            queries: {
                autoAuthorize: true,
                deepUpdate: true,
                workflowAction: 'update'
            }
        });
    },
    /**
     * Saves the payment auth and sends the entire page to braintree
     */
    submitForBalanceDue: function () {
        var paymentAuth = this.getCurrentBalanceDuePaymentAuthorization();
        return paymentAuth.save(null, {
            queries: { autoAuthorize: true }
        });
    },
    addCheckoutNote: function () {
        var offer;
        var note;

        if (!this.checkoutNote) {
            return;
        }

        offer = this.getFirstOffer();
        note = offer.newBuyerSellerNote({
            role: Party.ROLE_BUYER,
            creatorId: this.get('buyer.id')
        });

        note.set('anchors', []);
        note.set('content', this.checkoutNote);
        offer.set('notes', [note]);
    },
    isCheckoutComplete: function () {
        // checkout is complete when the transaction is saved and we have an offer payment auth
        return !this.isNew() &&
            (this.getCurrentCheckoutPaymentAuthorization() || this.getOfferPaymentAuthorization());
    },
    isBalanceDueProcessed: function () {
        // balance due is processed when we have a shipment quote payment auth
        return !!this.getShippingPaymentAuthorization();
    },

    needsToTransitionCheckoutPaymentAuth: function () {
        return !!this.getCheckoutPaymentAuthorizationForProcessing();
    },
    needsToTransitionBalanceDuePaymentAuth: function () {
        return !!this.getBalanceDuePaymentAuthorizationForProcessing();
    },
    getPermissibleCards: _.partial(getFromWallet, 'getPermissibleCards'),
    getValidPermissibleCards: _.partial(getFromWallet, 'getValidPermissibleCards'),
    // TODO combine with methods on offer model
    newBuyerOffer: function (amountPerItem, quantity) {
        var offers = this.get('offers');
        var offer = new Offer({
            quantity: quantity,
            amountPerItem: amountPerItem,
            subTotalAmount: {
                amount: Number(amountPerItem.get('amount') * quantity),
                currency: amountPerItem.get('currency')
            },
            forCompleteLot: !this.get('item').isSoldIndividually(),
            counterParty: {
                id: this.get('item.seller.id'),
                role: Party.ROLE_SELLER
            },
            initiatingParty: {
                id: this.get('buyer.id'),
                role: Party.ROLE_BUYER
            }
        });
        offers.reset([offer]);
        return offer;
    },
    lockConversionRates: function () {
        this.set('currencyConversionRateEvent', this.get('item.pricing.totalAmount.conversionRateEvent'));
    },
    _setFirstValidPermissibleCard: function (paymentAuth) {
        var cards = this.getValidPermissibleCards();
        if (cards && !cards.isEmpty()) {
            paymentAuth.set('paymentMethod', cards.first());
        }
        return paymentAuth;
    },
    /**
     * Creates a payment auth for checkout
     * @param [setCard] - defaults to true
     */
    createCheckoutPaymentAuthorization: function () {
        var currency = FinancialAmount.CURRENCY_USD;
        var paymentAuth = PaymentAuthorization.newOfferPaymentAuthorization();
        var amount = this.get('item').getAmountIn(currency);
        paymentAuth.set('amount', {amount: amount, currency: currency});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.set('paymentAuthorizations', [paymentAuth]);
    },
    createBalanceDuePaymentAuthorization: function () {
        var quote = this.getPaymentRequiredQuote();
        var paymentAuth;

        if (!quote) {
            return;
        }

        paymentAuth = PaymentAuthorization.newShipmentQuotePaymentAuthorization(quote);
        paymentAuth.set('transaction', {id: this.id});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.get('paymentAuthorizations').add(paymentAuth);
        return paymentAuth;
    },
    /**
     *
     * @param [id] optional address id to use
     */
    setInitialShippingAddress: function (id) {
        var addressBook = this.get('buyer.addressBook');
        var savedAddress = addressBook && addressBook.getAddressById(id);
        var firstShippingAddresses = this.getFirstShippingAddress();
        var address = savedAddress || firstShippingAddresses;
        if (address) {
            this.get('shipment').set('shippingAddress', address);
        }
    },
    addPromo: function (promoCode) {
        this.set('promotions', [{
            code: promoCode
        }]);
        this.trigger('promoChanged');
    },
    removePromo: function () {
        this.set('promotions', []);
        this.trigger('promoChanged');
    },
    /**
     * Invoke this function when a checkout has failed. Will clear the id
     * and payment auth so it can be submitted again
     */
    clearForCheckoutRetry: function () {
        this.unset('id');
        if (!this.isReadyForBalanceDue()) {
            this.selectFirstAvailableOption();
        }
        // remove status from sub documents
        this.unset('shipment.status');
        _.each(['invoices', 'offers'], function (collection) {
            this.get(collection).each(function (model) {
                model.unset('status');
            });
        }, this);
    },
    clearForDeniedPaymentAuth: function () {
        var paymentAuthorizations = this.get('paymentAuthorizations');
        var paymentAuth = paymentAuthorizations && paymentAuthorizations.last();
        var paymentMethod = paymentAuth && paymentAuth.get('paymentMethod');
        var newPaymentAuth;
        if (paymentAuth) {
            newPaymentAuth = new PaymentAuthorization(paymentAuth.pick('amount', 'anchor', 'transaction'));
            if (paymentMethod) {
                this.previousPaymentMethod = paymentMethod.makeNewCard();
                newPaymentAuth.set('paymentMethod', this.previousPaymentMethod);
            }
        }
        this.set('paymentAuthorizations', [newPaymentAuth]);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/ecomm/Transaction/transactionCheckoutMixin.js
// module id = 195
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55